import { useQuery } from '@tanstack/react-query'

import { useQueryErrorAlert } from '@hooks/useQueryErrorAlert'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchKlantgegevens } from '../services/fetchKlantgegevens'

export { useKlantgegevens }

const queryKey = 'klant'

const useKlantgegevens = ({ id }: { id: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isPending: isLoading,
    error,
    errorUpdatedAt,
  } = useQuery({
    queryKey: [queryKey, id],
    queryFn: () => fetchKlantgegevens({ id }),
    enabled: hasPermissions && !!id,
    refetchOnMount: true,
  })

  useQueryErrorAlert(
    error,
    errorUpdatedAt,
    'Fout bij ophalen van klantgegevens',
  )

  return {
    data: data || {},
    isLoading,
  }
}
